import script from "./template.vue?vue&type=script&lang=ts&setup=true"
export * from "./template.vue?vue&type=script&lang=ts&setup=true"

import "./template.vue?vue&type=style&index=0&id=cf9b34ee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf9b34ee"]])

export default __exports__